// Vilka användarnivåer ett uppdrag är tillgängligt för. Samma värden som profilgruppernas
// userFlags, så att de två inställningarna beter sig likadant.
export enum TitleUserFlagEnum {
  Association = 1,
  District = 2,
  Organization = 4,
  All = 7,
}
